exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".webapp {\n  background-color: #fff;\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.webapp .form-designer {\n  height: 800px;\n  overflow-y: scroll;\n}\n.webapp .form-designer .widget-config-container .el-tabs__header {\n  position: relative;\n}", ""]);

// exports
